export default __webpack_public_path__ + "static/char-s-48-zh-Hant-14bb20cf564aeb4bcea67c21d0f00291.webp";